var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.5 56",
    style: {
      enableBackground: "new 0 0 170.5 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2,26.4v-8.8h5.4V40h-5.4v-8.7H7.9V40H2.5V17.6h5.4v8.8H18.2z M39.7,40.3c-7.2,0-12.5-4.7-12.5-11.6 c0-6.7,5.5-11.6,12.6-11.6c3.6,0,7.1,1.4,9.2,3.6l-3.2,4c-1.5-1.4-3.5-2.5-6.1-2.5c-3.6,0-6.9,2.5-6.9,6.6s3.3,6.6,7.4,6.6 c2.7,0,4.7-1.3,6.1-2.5l2.6,4.2C47.2,38.7,43.5,40.3,39.7,40.3z M60.3,40.3c-6,0-10.2-3.7-10.2-8.8s4.2-8.8,10.2-8.8 c5.9,0,10.1,3.7,10.1,8.8S66.2,40.3,60.3,40.3z M60.3,35.9c2.8,0,5-1.9,4.9-4.4c0.1-2.6-2.1-4.4-4.9-4.4c-2.8,0-5.1,1.9-5,4.4 C55.3,34,57.5,35.9,60.3,35.9z M84.9,22.7c4.4,0,6.7,2.8,6.7,7.1V40h-5.2v-9.5c0-2.2-1.3-3.5-3.4-3.5c-2.4,0-3.9,1.8-3.9,3.5V40 h-2.6h-2.6V23H79l0.1,2.3C80.4,23.8,82.5,22.7,84.9,22.7z M107.6,22.7c4.4,0,6.7,2.8,6.7,7.1V40h-5.2v-9.5c0-2.2-1.3-3.5-3.4-3.5 c-2.4,0-3.9,1.8-3.9,3.5V40h-2.6h-2.6V23h4.9l0.1,2.3C103,23.8,105.1,22.7,107.6,22.7z M127.4,22.7c5.2,0,9.2,3.6,9.1,8.6l0,1.4 h-13.6c0.7,2,2.8,3.3,5.9,3.3c2.2,0,3.6-0.6,4.7-1.4l2.3,3.4c-2.2,1.6-4.9,2.5-7.7,2.5c-6.2,0-10.3-3.7-10.3-8.7 C117.7,26.2,122,22.7,127.4,22.7z M127.4,26.9c-2.4,0-4.1,0.9-4.7,2.8h9C131.5,28.1,129.7,26.9,127.4,26.9z M148.2,40.3 c-5.6,0-9.7-3.7-9.7-8.8c0-5.1,4.1-8.8,9.5-8.8c3.4,0,6.4,1.1,8.2,3l-2.8,3.5c-1.1-1.1-3-2-5-2c-2.9,0-4.8,1.8-4.8,4.4 c0,2.5,2,4.4,4.8,4.4c2.2,0,3.8-0.8,5-1.8l2.8,3.5C154.4,39.2,151.5,40.3,148.2,40.3z M166.3,23h4.3v4.5h-4.3V40h-5.2V27.5h-3.8V23 h3.8v-4.7h5.2V23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHconnect);
export default __webpack_public_path__ + "static/media/hconnect.c4fa9791bc2ecd504a41da040f038ca3.svg";
export { ForwardRef as ReactComponent };